import { number, string } from "prop-types";
import { useEffect, useState } from "react";

import { FAMILY_RELATIONSHIP_PICKER } from "Flocknote/GlobalComponents/Modal/contentKeys";
import { useModal } from "Flocknote/stateHooks";

import {
  useGetHouseholdDataByUserID,
  useGetHouseholdDetail,
} from "HouseholdProfile/API/queries";

import useOpenHouseholdProfile from "Utilities/Hooks/useOpenHouseholdProfile";
import { useUserID } from "Utilities/urlParamHooks";

import GoToProfile from "./GoToProfile";

const ButtonSwitch = ({ userID, householdID, householdName, ...rest }) => {
  const [isCreatingNewHousehold, setIsCreatingNewHousehold] = useState();
  const [{ contentKey }] = useModal();
  const openHouseholdProfile = useOpenHouseholdProfile({ householdID });

  useEffect(() => {
    if (contentKey === FAMILY_RELATIONSHIP_PICKER)
      setIsCreatingNewHousehold(true);
  }, [contentKey]);

  useEffect(() => {
    // If the modal was open, and now there is a household ID, that means we have a new household. Let's open it up.
    if (isCreatingNewHousehold && householdID) {
      openHouseholdProfile();
      setIsCreatingNewHousehold(false);
    }
  }, [householdID, isCreatingNewHousehold, openHouseholdProfile]);

  return (
    <GoToProfile
      householdID={householdID}
      householdName={householdName}
      userID={userID}
      {...rest}
    />
  );
};

// Thee props are passed into the make the animations work correctly. If extending this component further, make a context.
ButtonSwitch.propTypes = {
  userID: number,
  householdID: number,
  householdName: string,
};

const GoToOrCreateHousehold = () => {
  const userID = useUserID();

  // The query behind useGetHouseholdDataByUserID is cleared by useClearGetHouseholdDataByUserID.
  // This is how the old relationship picker updates the householdID
  const { data: { householdName, householdID } = {} } =
    useGetHouseholdDataByUserID(userID);

  // currently, useGetHouseholdDataByUserID fails for non-FNC networks as technically they don't
  // have the households feature. But we can get it from the householdDetail query.
  const { data: householdDetailData } = useGetHouseholdDetail();
  const detailHouseholdID = householdDetailData?.householdProfile?.householdID;

  return (
    <ButtonSwitch
      userID={userID}
      householdID={householdID || detailHouseholdID}
      householdName={householdName}
      data-cy="GoToOrCreateHousehold_Container"
    />
  );
};

export default GoToOrCreateHousehold;
